import MainLayout from 'components/layout/MainLayout';
import { useIsMobile } from 'hooks/ui/useIsMobile';
import React, { ReactNode } from 'react';

import EnterFlowFooter from '../EnterFlowFooter';
import MembershipSummary from '../MembershipSummary';
import { V2NavigationRight } from '../Navigation';
import TitleSection, { InfoGraphicRow } from '../TitleSection';
import { useIsStuck } from '../useIsStuck';
import { useScrollFade } from '../useScrollFade';
import styles from './V2EnterLayout.module.css';
import { enterFlowSubtitle, enterFlowTitle } from './V2EntriesAndDays';
import V2EntriesPicker from './V2EntriesPicker';

interface V2EnterLayoutProps {
  checkoutPage?: boolean;
  mobileBottom: ReactNode;
  desktopLeft: ReactNode;
  desktopRight: ReactNode;
}
export const V2_ENTER_LAYOUT_SCROLL_POSITION_MARKER =
  'V2_ENTER_LAYOUT_SCROLL_POSITION_MARKER';

export const V2EnterLayout: React.FC<V2EnterLayoutProps> = ({
  checkoutPage,
  mobileBottom,
  desktopLeft,
  desktopRight,
}: V2EnterLayoutProps) => {
  const { isMobile } = useIsMobile();
  const titleRef = useScrollFade(90);
  const [stickyRef, isStuck] = useIsStuck(82);

  const title = enterFlowTitle(checkoutPage);
  const subitle = enterFlowSubtitle(checkoutPage);

  return (
    <MainLayout
      limitItemWidths
      hideHeader
      additionalClassName="daymadeTypographyReset"
    >
      {isMobile ? (
        <div className={styles.mobileContainer}>
          <V2NavigationRight />
          <div ref={titleRef} className={styles.v2EnterLayoutTitleFadeOnScroll}>
            <TitleSection
              title={title}
              subtitle={subitle}
              displayMascot={!checkoutPage}
              lightMode
            />
          </div>
          <div ref={stickyRef} aria-hidden style={{ height: 1 }} />
          {!checkoutPage && (
            <div
              className={styles.entriesPicker}
              id={V2_ENTER_LAYOUT_SCROLL_POSITION_MARKER}
            >
              <V2EntriesPicker isStuck={isStuck} />
            </div>
          )}
          {checkoutPage && (
            <div className={styles.membershipSummary}>
              <MembershipSummary checkoutPage />
            </div>
          )}
          <div className={styles.infoGraphicFlowTwo}>
            <InfoGraphicRow lightMode />
          </div>
          <div className={styles.mobileBottom}>
            {mobileBottom}
            <EnterFlowFooter />
          </div>
        </div>
      ) : (
        <div className={styles.desktopContainer}>
          <div className={styles.desktopLeft}>
            <div className={styles.desktopLeftInner}>{desktopLeft}</div>
          </div>
          <div className={styles.desktopRight}>
            <div className={styles.desktopRightInner}>
              {desktopRight}
              <div className={styles.desktopRightFooter}>
                <EnterFlowFooter variant="V2" />
              </div>
            </div>
          </div>
        </div>
      )}
    </MainLayout>
  );
};

export default V2EnterLayout;
